import { EditableTableColumn } from '../../models/editable-table-column.model';

// Shared by EditableTableComponent (search filtering, sort, hasEmptyRequired) and
// EditableTableRowComponent (per-cell tooltip/validation) — pure functions of a
// single row + column, no component state, so both can use the exact same rule.

export function isColumnEmpty<T>(row: T, col: EditableTableColumn<T>): boolean {
  const value = (row as any)[col.field];
  return value === null || value === '' || value === undefined;
}

export function isRequiredEmpty<T>(row: T, col: EditableTableColumn<T>): boolean {
  return !!col.required && isColumnEmpty(row, col);
}

export function getDisplayText<T>(row: T, col: EditableTableColumn<T>): string {
  if (col.getDisplayText) return col.getDisplayText(row) ?? '';
  if (col.displayField) return String((row as any)[col.displayField] ?? '');
  if (col.type === 'dropdown' || col.type === 'dropdown-search') {
    const value = (row as any)[col.field];
    const opt = col.options?.find((o) => o[col.optionValue ?? 'id'] === value);
    return opt ? String(opt[col.optionLabel ?? 'name'] ?? '') : '';
  }
  if (col.type === 'date') {
    const value = (row as any)[col.field];
    return value ? new Date(value).toLocaleString() : '';
  }
  return String((row as any)[col.field] ?? '');
}
